export const POSTHOG_EVENTS = {
  ACCOUNT_CREATED: "Account Created",
  LOGIN: "User Logged In",
  // Same names as mobile, so LINE sign-in reads the same from either client.
  LINE_LOGIN_CLICKED: "LINE Login Clicked",
  LINE_LOGIN_CANCELLED: "LINE Login Cancelled",
  LINE_LOGIN_ERROR: "LINE Login Error",
  GROUP_CREATED: "Group Created",
  // Same names as mobile, so a roster edit reads the same from either client.
  GROUP_PLAYER_ADDED: "Group Player Added",
  GROUP_PLAYER_REMOVED: "Group Player Removed",
  SESSION_CREATED: "Session Created",
  SESSION_RECORD_STARTED: "Session Record Started",
  SESSION_RECORD_FINISHED: "Session Record Finished",
  SESSION_TAG_CREATED: "Session Tag Created",
  SESSION_TAG_UPDATED: "Session Tag Updated",
  SESSION_TAG_REMOVED: "Session Tag Removed",
  SESSION_TAG_CREATE_FAILED: "Session Tag Create Failed",
  // Same names as mobile's ClipCardV4 verify button.
  SHOT_VERIFIED: "Verify Shot",
  SHOT_UNVERIFIED: "Unverify Shot",
  SESSION_VERIFIED_PERCENT_EDITED: "Edit session verified percent",
  MIXTAPE_CREATED: "Mixtape Created",
  MIXTAPE_EDITED: "Mixtape Edited",
  DELETE_ACCOUNT: "Delete Account",
  DELETE_ACCOUNT_ERROR: "Delete Account Error",
  // Same names and properties as mobile's paywall, plus platform: "web".
  PAYWALL_OPENED: "Paywall Opened",
  CHECKOUT_STARTED: "Checkout Started",
  CHECKOUT_FAILED: "Checkout Failed",
} as const;

export type PostHogEventName =
  (typeof POSTHOG_EVENTS)[keyof typeof POSTHOG_EVENTS];
